"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTheme = exports.setTheme = exports.RED = exports.GREEN_LIGHT = exports.GREEN = exports.YELLOW = exports.BLUE_LIGHT_2 = exports.BLUE_LIGHT = exports.BLUE = exports.GRAY_4 = exports.GRAY_3 = exports.GRAY_2 = exports.GRAY_1 = exports.GRAY = exports.WHITE = exports.BLACK = void 0;
const browser_1 = require("./browser");
exports.BLACK = '#282c37';
exports.WHITE = '#ffffff';
exports.GRAY = '#555';
exports.GRAY_1 = '#eef1f6';
exports.GRAY_2 = '#dddddd';
exports.GRAY_3 = '#c2c2c2';
exports.GRAY_4 = '#aabec6';
exports.BLUE = '#0047a9';
exports.BLUE_LIGHT = '#0c65c7';
exports.BLUE_LIGHT_2 = '#59cbe8';
exports.YELLOW = '#f5a623';
exports.GREEN = '#34bf6d';
exports.GREEN_LIGHT = '#2ec562';
exports.RED = '#d62729';
let theme = {
    textColor1: exports.BLACK,
    textColor2: exports.BLUE_LIGHT,
    textColor3: exports.GRAY,
    textColor4: exports.WHITE,
    messageTextColor: exports.BLACK,
    counterTextColor: exports.WHITE,
    dropDownTextColor: exports.BLACK,
    questionTextColor: exports.BLACK,
    datePickerColor: exports.BLUE_LIGHT_2,
    backgroundColor1: exports.WHITE,
    backgroundColor2: exports.GRAY_1,
    backgroundColor3: exports.BLUE_LIGHT,
    borderColor1: exports.GRAY_3,
    shadowColor1: exports.GRAY_4,
    statusBarColor: exports.BLUE,
    successColor: exports.GREEN_LIGHT,
    warningColor: exports.YELLOW,
    errorColor: exports.RED,
    disabledColor: exports.GRAY_2,
    counterBackgroundColor: exports.GREEN,
    fontFamily1: 'Roboto-Medium',
    fontFamily2: 'Roboto',
    fontFamily3: 'Roboto-Light'
};
const setTheme = (newTheme) => {
    theme = Object.assign(Object.assign({}, theme), newTheme);
    (0, browser_1.setDatePickerColor)(theme.datePickerColor);
};
exports.setTheme = setTheme;
const getTheme = () => {
    return theme;
};
exports.getTheme = getTheme;
